module.exports = __webpack_public_path__ + "assets/d627ef8cd36147e6495cf32c649cda64.png";